var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("MonitorLayoutTemplate", {
    attrs: { table_title: _vm.table_title },
    scopedSlots: _vm._u([
      {
        key: "datetime",
        fn: function() {
          return [
            _c("QpeDatetime", {
              attrs: {
                props_date: _vm.date,
                props_time: _vm.time,
                name: _vm.default_value
              },
              on: {
                "update-time": _vm.update_time,
                "change-parent-date-time": _vm.change_parent_date_time
              }
            })
          ]
        },
        proxy: true
      },
      {
        key: "data_table",
        fn: function(slot_props) {
          return [
            _c("QpeDatatable", {
              attrs: {
                data: _vm.table_data,
                headers: _vm.header,
                name: _vm.default_value,
                error_text: _vm.error_text,
                props_date: _vm.date,
                props_time: _vm.time,
                search: slot_props.search,
                should_show_raw_html_header: _vm.should_show_raw_html_header,
                show_download_pdf_btn: true,
                show_footer: false
              },
              on: {
                "update-time": _vm.update_time,
                "change-parent-date-time": _vm.change_parent_date_time
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "table_description",
                    fn: function() {
                      return [
                        _c("div", [
                          _vm._v("\n                    閃電警示"),
                          _c("br"),
                          _vm._v("\n                    燈號說明："),
                          _c("br"),
                          _vm._v("\n                    紅燈 "),
                          _c("span", {
                            staticClass: "description-dot",
                            staticStyle: { background: "#f00" }
                          }),
                          _vm._v(" 0-10km有閃電發生"),
                          _c("br"),
                          _vm._v(
                            "\n                    閃電資料來源：氣象署\n                "
                          )
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v("\n                    QPE警示"),
                          _c("br"),
                          _vm._v("\n                    燈號說明："),
                          _c("br"),
                          _vm._v("\n                    紅燈 "),
                          _c("span", {
                            staticClass: "description-dot",
                            staticStyle: { background: "#f00" }
                          }),
                          _vm._v(" 0-10km有QPE大於40mm"),
                          _c("br"),
                          _vm._v(
                            "\n                    QPE資料來源：氣象署\n                "
                          )
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v("\n                    對流胞警示"),
                          _c("br"),
                          _vm._v("\n                    燈號說明："),
                          _c("br"),
                          _vm._v("\n                    紅燈 "),
                          _c("span", {
                            staticClass: "description-dot",
                            staticStyle: { background: "#f00" }
                          }),
                          _vm._v(" (紅燈)0-10km有對流胞在範圍內"),
                          _c("br"),
                          _vm._v(
                            "\n                    對流胞資料來源：氣象署\n                "
                          )
                        ])
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                true
              )
            })
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }